import { optionsConstants } from '../redux-constants'

export function updateOptions(key, payload) {
    return (dispatch, getState, { firebase, firestore }) => {
        dispatch(updateOption({ [key]: payload }))
    }
}

export function updateOption(payload) {
    return {
        type: optionsConstants.UPDATE,
        payload,
    }
}
